import { WorkflowSchema } from "./workflow-schema"
import { DateContainer } from "./date-container"

export enum MovementTypes {
    COMPLEX = 'complex',
    RETURN = 'returning',
    SIMPLE = 'simple',
}

export enum MovementLifecycleStates {
    ARCHIVED = 'archived',
    CANCELED = 'canceled',
    FINALIZED = 'finalized',
    IN_PREPARATION = 'inPreparation',
    IN_PROGRESS = 'inProgress',
    PROGRAMMED = 'programmed',
}

export interface Movement {
    id: string,
    movementSchema: {
        affectedStorekeepers: string[],
        plannedDate: {
            endDate: DateContainer,
            startDate: DateContainer,
        },
    },
    movementType: MovementTypes,
    workflowSchema: WorkflowSchema<MovementLifecycleStates> & {
        usePermanentLocationForDestination?: boolean,
    },
}